var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-img",class:{'has-intersected': _vm.intersected},style:(_vm.elementStyles)},[_c('img',{staticClass:"vertical-img__elem",class:_vm.imageClass,attrs:{"src":_vm.srcImage,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }